module.exports = __webpack_public_path__ + "static/media/View.9e87ef34.svg";